/**
 * @fileoverview The i18next namespace `@puffin-core/form-security` registers under.
 * @package @puffin-core/form-security
 *
 * Its own module so `useFormSecurityTranslate` and the registrar can both import the constant
 * without either importing the other's module graph — the same split `@puffin-core/captcha-ui`
 * uses for `CAPTCHA_NAMESPACE`.
 */

export const FORM_SECURITY_NAMESPACE = 'formSecurity';

export default FORM_SECURITY_NAMESPACE;
